import { SxProps } from '@mui/material';
import { black1, grey9 } from 'app/components/ThemeProvider/colors';

export const secondaryText = {
  fontSize: '16px',
  fontWeight: 400,
  color: '#14191F8F',
};

export const mainText = {
  fontSize: '20px',
  fontWeight: 600,
};
export const iconBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '24px',
};

export const accordionSummary: SxProps = {
  height: '97px',
  padding: '32px 28px',
  '&.Mui-disabled': {
    opacity: 1,
  },
};

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};
